import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import * as reducers from "./reducers";

export default configureStore({
  middleware: [thunk],
  reducer: { ...reducers },
});
